module.exports = __webpack_public_path__ + "static/media/Acetab and femoral.f642e15a.png";